import { Box, IconButton, Typography } from "@mui/material";
import {
  IdsChevronLeft as ChevronLeftIcon,
  IdsChevronRight as ChevronRightIcon,
} from "components/shared/svgIcons";
import { makeStyles } from "@mui/styles";

import { colors } from "theme";

const useStyles = makeStyles(() => ({
  pagination: {
    "& .MuiIconButton-root.Mui-disabled": {
      color: colors.semantic.neutral,
      opacity: 1,
    },
  },
}));

const Pagination = ({
  totalCount,
  pageSize = 20,
  currentPage,
  setCurrentPage,
}: {
  totalCount: number;
  pageSize?: number;
  currentPage: number;
  setCurrentPage: Function;
}) => {
  const classes = useStyles();

  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={classes.pagination}
    >
      <IconButton
        color="secondary"
        disableRipple
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
        size="large">
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="body2">
        Showing {Math.min((currentPage - 1) * pageSize + 1, totalCount)}-
        {Math.min(currentPage * pageSize, totalCount)} of {totalCount}
      </Typography>
      <IconButton
        color="secondary"
        disableRipple
        disabled={currentPage * pageSize >= totalCount}
        onClick={() => setCurrentPage(currentPage + 1)}
        size="large">
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default Pagination;
